import { gql } from '@apollo/client';

export const twilioMessageHistoryQuery = gql`
  query twilioMessageHistory($phone: String!, $limit: Int) {
    twilioMessageHistory(phone: $phone, limit: $limit) {
      sid
      from
      to
      body
      status
      direction
      sentAt
      errorCode
      errorMessage
    }
  }
`;

export interface TwilioMessage {
  sid: string;
  from: string;
  to: string;
  body: string | null;
  status: string;
  direction: string;
  sentAt: string;
  errorCode: number | null;
  errorMessage: string | null;
}

export interface TwilioMessageHistoryData {
  twilioMessageHistory: TwilioMessage[];
}

export interface TwilioMessageHistoryVars {
  phone: string;
  limit?: number;
}
